import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import {AuditTable} from './table';
import { useHistory, Redirect, useLocation } from 'react-router';

import { fetchActivityLog } from '../../actions/funecap/activityLog';

export const Audit = ({ activityLogReducer, partner, teleconseillersReducer }) => {
	const dispatch = useDispatch();
    const history = useHistory();
	const location = useLocation();
    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(lastWeek.getDate() - 7);
    const searchParams = new URLSearchParams(location.search);

    let fromDate = searchParams.get('from');
    let toDate = searchParams.get('to');
	let operatorId = searchParams.get('operatorId');
    let userId = searchParams.get('userId');
    let pageSize = searchParams.get('pageSize');
    let continuationToken = searchParams.get('continuationToken');
	let sortBy = searchParams.get('sortBy');
	let sortDesc = searchParams.get('sortDesc');

    fromDate = R.isNil(fromDate) ? lastWeek.toISOString().split('T')[0] : fromDate;
    toDate =  R.isNil(toDate) ? today.toISOString().split('T')[0] : toDate;
    pageSize = R.isNil(pageSize) ? null : parseInt(pageSize);
    continuationToken = R.isNil(continuationToken) ? activityLogReducer.continuationToken : continuationToken;
	sortBy = R.isNil(sortBy) ? "date" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;

	useEffect(() => {
		if(location.search !== ""){
			dispatch(fetchActivityLog(partner.id, fromDate, toDate, pageSize, operatorId, userId, continuationToken));
		}
		
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search])

    const routerQuery = {
		fromDate,
		toDate,
		pageSize,
		operatorId,
		userId,
        continuationToken,
		sortBy,
		sortDesc
	};

	if(window.location.search === ""){
		return <Redirect to={`/funecap/audit?from=${fromDate}&to=${toDate}&sortBy=${sortBy}${R.isNil(pageSize) ? '' : '&pageSize=' + pageSize}${R.isNil(continuationToken) ? '' : '&continuationToken=' + continuationToken}`} />
	}
    return (
		<React.Fragment>
			<AuditTable activityLogReducer={activityLogReducer} routerQuery={routerQuery} />
			{/* <div className="container-fluid">
				<nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">

				</nav>
			</div> */}
		</React.Fragment>
	);
}